import React from "react";
import classnames from "classnames";
import { usePagination } from "./usePagination";

const Pagination = ({
  onPageChange,
  totalCount,
  siblingCount = 1,
  currentPage,
  pageSize,
  className,
  jobList,
}) => {
  // Calculate total pages based on the filtered job list
  const totalPages = Math.ceil(jobList.length / pageSize);

  const paginationRange = usePagination({
    totalCount: totalPages,
    pageSize,
    siblingCount,
    currentPage,
  });

  const onNext = () => {
    if (currentPage === totalPages) return;
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage <= 1) return;
    onPageChange(currentPage - 1);
  };

  // Conditionally render pagination only if there are more than 1 page
  const shouldRenderPagination = totalPages > 1;

  return (
    <>
      {shouldRenderPagination && (
        <ul className={classnames("pagination", { [className]: className })}>
          <li
            className={classnames("page-item", {
              disabled: currentPage === 1,
            })}
            onClick={onPrevious}
          >
            <a
              className="page-link"
              href="javascript:void(0)"
              aria-label="Previous"
            >
              <span aria-hidden="true">&laquo;</span>
              <span className="sr-only">Previous</span>
            </a>
          </li>

          {/* Render pagination links */}
          {paginationRange.map((pageNumber, index) => (
            <li
              key={index}
              className={classnames("page-item", {
                selected: pageNumber === currentPage,
              })}
              onClick={() => onPageChange(pageNumber)}
            >
              <a
                className={classnames("page-link", {
                  active: pageNumber === currentPage,
                })}
                href="javascript:void(0)"
                style={{
                  backgroundColor:
                    pageNumber === currentPage ? "#CE2029" : "inherit",
                }}
              >
                {pageNumber}
              </a>
            </li>
          ))}

          <li
            className={classnames("page-item", {
              disabled: currentPage === totalPages || jobList.length === 0,
            })}
            onClick={onNext}
          >
            <a
              className="page-link"
              href="javascript:void(0)"
              aria-label="Next"
            >
              <span className="sr-only">Next</span>
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
          {/* Separate block for "Total Pages" */}
        </ul>
      )}
    </>
  );
};

export default Pagination;
